/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import Flex from '../Flex';

export const AdvanceTableFooter1 = ({
  page,
  pageSize,
  pageIndex,
  rowCount,
  setPageSize,
  canPreviousPage,
  canNextPage,
  nextPage,
  previousPage,
  rowInfo,
  rowsPerPageSelection,
  navButtons,
  rowsPerPageOptions = [15, 30, 45, 60],
  className
}) => {
  const changeSrNo = () => {
    // var srNoStart = pageSize * pageIndex + 1;
    var srNoStart =
      pageIndex === 1 ? pageIndex : pageSize * (pageIndex - 1) + 1;

    $('#advanceTable td:nth-child(1)').each(function () {
      $(this).text(srNoStart++);
    });
  };

  setTimeout(function () {
    changeSrNo();
  }, 100);

  return (
    <Flex
      className={classNames(
        className,
        'align-items-center justify-content-between action-page-parent'
      )}
    >
      <Flex alignItems="center" className="fs--1 action-pagesize">
        {rowInfo && (
          <p className="mb-0">
            <span className="d-none d-sm-inline-block me-2">
              {/* {pageSize * pageIndex + 1} to {pageSize * pageIndex + page.length}{' '}
              of {rowCount} */}
              {Math.min(pageSize * (pageIndex - 1) + 1, rowCount)} to{' '}
              {Math.min(pageSize * pageIndex, rowCount)} of {rowCount}
            </span>
          </p>
        )}
        {(rowsPerPageSelection && location.pathname !== '/dashboard') && (
          <>
            <p className="mb-0 mx-2">Rows per page:</p>
            <Form.Select
              size="sm"
              className="w-auto"
              onChange={e => setPageSize(e.target.value)}
              defaultValue={15}
            >
              {rowsPerPageOptions.map(value => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </>
        )}
      </Flex>
      {navButtons && (
        <Flex className='action-button'>
          <Button
            size="sm"
            variant={canPreviousPage ? 'primary' : 'light'}
            onClick={() => previousPage()}
            className={classNames({ disabled: !canPreviousPage })}
          >
            Previous
          </Button>
          <Button
            size="sm"
            variant={canNextPage ? 'primary' : 'light'}
            className={classNames('px-4 ms-2', {
              disabled: !canNextPage
            })}
            onClick={() => nextPage()}
          >
            Next
          </Button>
        </Flex>
      )}
    </Flex>
  );
};

export default AdvanceTableFooter1;
